import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.isOpen = false;

    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    this.boundHandleKeydown = this.handleKeydown.bind(this);
    this.boundHandleResize = this.handleResize.bind(this);

    document.addEventListener("click", this.boundHandleClickOutside);
    document.addEventListener("keydown", this.boundHandleKeydown);
    window.addEventListener("resize", this.boundHandleResize);
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside);
    document.removeEventListener("keydown", this.boundHandleKeydown);
    window.removeEventListener("resize", this.boundHandleResize);
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.updateMenuVisibility();
  }

  close() {
    this.isOpen = false;
    this.updateMenuVisibility();
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target) && this.isOpen) {
      this.close();
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close();
    }
  }

  handleResize() {
    if (this.isOpen) {
      this.adjustPositioning();
    }
  }

  updateMenuVisibility() {
    if (this.isOpen) {
      this.menuTarget.classList.remove("hidden");
      requestAnimationFrame(() => {
        this.adjustPositioning();
      });
    } else {
      this.menuTarget.classList.add("hidden");
    }
  }

  adjustPositioning() {
    if (!this.hasMenuTarget) {
      return;
    }

    const menu = this.menuTarget;
    const viewportWidth = window.innerWidth;
    const containerRect = this.element.getBoundingClientRect();
    const preferRightAlignment = (containerRect.left + containerRect.width / 2) > (viewportWidth / 2);

    menu.classList.remove("left-0", "right-0");

    if (preferRightAlignment) {
      menu.classList.add("right-0");
    } else {
      menu.classList.add("left-0");
    }

    const menuRect = menu.getBoundingClientRect();

    if (preferRightAlignment && menuRect.left < 0) {
      menu.classList.remove("right-0");
      menu.classList.add("left-0");
    } else if (!preferRightAlignment && menuRect.right > viewportWidth) {
      menu.classList.remove("left-0");
      menu.classList.add("right-0");
    }
  }
}
